export default {
  app: 'APP_BCG',
  api: '/portal'
};
